module.exports = __webpack_public_path__ + "static/media/zip.285c44b6.png";